import { render, staticRenderFns } from "./process-tab.vue?vue&type=template&id=47be8cc6"
import script from "./process-tab.vue?vue&type=script&lang=js"
export * from "./process-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports